var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgTitle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 190,
  height: 31,
  viewBox: "0 0 190 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M182 0C186.418 0 190 3.58172 190 8V23C190 27.4183 186.418 31 182 31H8C3.58172 31 0 27.4183 0 23V8C0 3.58172 3.58172 0 8 0H182Z",
  fill: "black",
  fillOpacity: 0.1
})));
export default SvgImgTitle;